<template>
    <div class="ah-page project-page" @click="onPageClick">
        <div class="page-header" id="project-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>專案管理</h1>
                        <el-radio-group v-model="currentPage" size="small" class="table-option-block" @change="onCurrentPageChange">
                            <el-radio-button :label="1" class="table-option">明細表</el-radio-button>
                            <el-radio-button :label="2" class="table-option">年度分佈表</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="actions">
                        <el-button v-if="isAuthOne(['C01', 'C04'])" type="highlight" class="custom-actions" @click="handleAddBtnClick" icon="el-icon-plus">新增專案</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <div class="query-input-row" :class="`current-page-${currentPage}`">
                    <div class="item">
                        <div class="label">專案開始日期</div>
                        <div class="query-input" style="max-width: 290px; min-width: 250px;">
                            <el-date-picker
                                v-if="currentPage === 1"
                                :default-time="['00:00:00', '23:59:59']"
                                prefix-icon="-"
                                v-model="queryParams.pjStartDate"
                                value-format="timestamp"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                style="width: 100%"
                                size="small"
                                :clearable="true"
                                :picker-options="pickerOptions"
                                @change="updateData"
                            ></el-date-picker>
                            <ahElYearPicker v-else-if="queryParams.pjStartDate" v-model="queryParams.pjStartDate" style="width: 230px" @change="updateData" />
                        </div>
                    </div>
                    <div v-if="currentPage === 1" class="item">
                        <div class="label">專案結束日期</div>
                        <div class="query-input" style="max-width: 290px; min-width: 250px;">
                            <el-date-picker
                                :default-time="['00:00:00', '23:59:59']"
                                v-model="queryParams.pjEndDate"
                                value-format="timestamp"
                                prefix-icon="-"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                style="width: 100%"
                                size="small"
                                :clearable="false"
                                :picker-options="pickerOptions"
                                @change="updateData"
                            ></el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">專案狀態</div>
                        <div class="query-input" style="width: 142px;">
                            <el-select size="small" v-model="queryParams.STG_STS" @change="updateData">
                                <el-option :key="0" label="不限" :value="null" />
                                <el-option :key="1" label="進行中" :value="false" />
                                <el-option :key="2" label="結案" :value="true" />
                            </el-select>
                        </div>
                    </div>
                    <div class="item" style="flex-grow: 1;">
                        <div class="label">客戶</div>
                        <div class="query-input" style="width: 100%;">
                            <el-select
                                size="small"
                                v-model="queryParams.VDR_SNOs"
                                :placeholder="companyInfo.displayClient ? '請選擇' : '請輸入客戶關鍵字（至少兩個字）'"
                                :remote-method="vendorRemoteMethod"
                                @change="updateData"
                                @keydown.native.capture.enter="preventIMESelect"
                                style="width: 100%; min-width: 200px;"
                                multiple filterable remote clearable
                            >
                                <el-option :value="item.sno" :label="item.fnam" v-for="item in vendorOptions" :key="item.sno"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="query-input-row" :class="`current-page-${currentPage}`">
                    <div class="item" style="min-width: 240px;">
                        <div class="label">專案類別</div>
                        <div class="query-input">
                            <el-select size="small" v-model="queryParams.PJCAT_SNOs" multiple filterable reserve-keyword @change="updateData" placeholder="">
                                <el-option v-for="item in projectCatOptions" :key="item.sno" :label="item.pjcaT_NAM" :value="item.sno" />
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">專案經理 (PM)</div>
                        <div class="query-input" style="min-width: 241px;">
                            <el-select size="small" v-model="queryParams.searchPMs" multiple filterable reserve-keyword @change="updateData" placeholder="">
                                <el-option v-for="item in pmOptions" :value="item.sno" :label="item.active ? item.nam : `${item.nam}（已停用）`" :key="item.sno"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">專案經辦人 (PA)</div>
                        <div class="query-input" style="min-width: 241px;">
                            <el-select size="small" v-model="queryParams.searchPAs" multiple filterable reserve-keyword @change="updateData" placeholder="">
                                <el-option v-for="item in paOptions" :value="item.sno" :label="item.active ? item.nam : `${item.nam}（已停用）`" :key="item.sno"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item" style="flex-grow: 1;">
                        <div class="label">專案名稱</div>
                        <div class="query-input">
                            <el-input size="small" v-model="queryParams.Keyword" placeholder="專案名稱、單號、自訂編號" @keydown.enter.native="updateData" clearable style="min-width: 200px;" />
                        </div>
                    </div>
                    <div class="item" style="min-width: 100px;">
                        <div class="label">固定搜尋條件</div>
                        <div class="query-input">
                            <div style="padding: 7px 0 0 0; margin-left: -10px;"><ahMiniSwitch v-model="fixSearch" name="" @change="onFixSearchChange" /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color" style="padding: 20px 0 10px 0">
            <div class="ah-container">
                <ProjectDetailStatisticBoard v-if="currentPage === 1" ref="ProjectDetailStatisticBoard" :data="progressOverview" :isLoading="isLoading" />
                <ProjectYearlyCompareTable v-else-if="currentPage === 2" ref="ProjectYearlyCompareTable" :data="summaryData" :isLoading="isLoading" />
            </div>
        </div>
        <div class="ah-container main-table">
            <div class="ah-panel" style="border-top-left-radius: 0; border-top-right-radius: 0">
                <div class="panel-body">
                    <ProjectDetailTableView
                        v-if="currentPage === 1"
                        :datas="datas"
                        :isLoading="isLoading"
                        :pageSize="queryParams.PageSize"
                        :currPage="queryParams.PageNum"
                        @row-click="handleDataRowClick"
                        @refresh="onRefresh"
                    >
                        <template slot="top-right-actions">
                            <span class="hint-label">{{ dateOfToday }} 即時資料，以下皆為含稅金額。</span>
                            <el-button type="normal" size="small" @click="exportExcelDialog.visible = true">匯出Excel</el-button>
                        </template>
                    </ProjectDetailTableView>
                    <ProjectYearlyStatisticView
                        v-else-if="currentPage === 2"
                        :datas="datas"
                        :isLoading="isLoading"
                        :get-row-class="getRowClass"
                        :pj-start-date="queryParams.pjStartDate"
                        :pageSize="queryParams.PageSize"
                        :currPage="queryParams.PageNum"
                        @row-click="handleDataRowClick"
                        @refresh="onRefresh"
                    >
                        <template slot="top-right-actions">
                            <span class="hint-label">{{ dateOfToday }} 即時資料，以下皆為含稅金額。</span>
                        </template>
                    </ProjectYearlyStatisticView>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="onPaginationChange"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <ProjectDetailDialog ref="projectDetailDialog" :visible="projectDetailDialog.visible" :sno="projectDetailDialog.sno" @update="updateData" @close="handleDetailDialogClose" />
        <ProjectExportExcelDialog
            ref="exportExcelDialog"
            :visible="exportExcelDialog.visible"
            :isExporting="isLoadingExport"
            @close="exportExcelDialog.visible = false"
            @export="onExport"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { datePickerOption } from '@/assets/commonData/options';

import ahElYearPicker from '@/components/ui/ahElYearPicker.vue';
import ahMiniSwitch from '@/components/ui/ahMiniSwitch.vue';
import ProjectDetailDialog from './ProjectDetailDialog.vue';
import ProjectExportExcelDialog from './ProjectExportExcelDialog.vue';
import ProjectExportMixins from './ProjectExportMixins';
import ProjectDetailTableView from './ProjectDetailTableView.vue';
import ProjectYearlyStatisticView from './ProjectYearlyStatisticView.vue';
import ProjectDetailStatisticBoard from './ProjectDetailStatisticBoard.vue';
import ProjectYearlyCompareTable from './ProjectYearlyCompareTable.vue';

export default {
    name: 'ProjectPage',
    mixins: [ProjectExportMixins],
    components: {
        ProjectDetailDialog,
        ProjectExportExcelDialog,
        ProjectDetailTableView,
        ProjectYearlyStatisticView,
        ahElYearPicker,
        ProjectDetailStatisticBoard,
        ProjectYearlyCompareTable,
        ahMiniSwitch,
    },
    data() {
        return {
            // =========================== NEW ===========================
            projectCatOptions: [],
            pmOptions: [],
            paOptions: [],

            queryParams: {
                pjStartDate: [],
                pjEndDate: [],
                STG_STS: null,
                PJCAT_SNOs: [],
                Keyword: null,
                searchPMs: [],
                searchPAs: [],
                VDR_SNOs: [],
                PageSize: 25,
                PageNum: 1,
            },

            datas: [],
            summaryData: [],
            isLoading: false,

            currentPage: 1,
            progressOverview: {},
            fixSearch: false,
            // =========================== ORIGINAL ===========================

            projectDetailDialog: {
                visible: false,
                sno: null,
                lastSno: null,
            },
            exportExcelDialog: {
                visible: false,
            },
            vendorOptions: [],
            totalDataCount: 0,
            isLoadingExport: false,
            pickerOptions: datePickerOption,
        };
    },
    created() {
        const START_DATE = moment().startOf('year').format('x');
        const END_DATE = moment().endOf('year').subtract(1, 'seconds').format('x');
        this.queryParams.pjStartDate = [START_DATE, END_DATE];

        const STORED_QUERY = localStorage.getItem('project-list-query');
        if (STORED_QUERY) {
            this.queryParams = JSON.parse(STORED_QUERY);
            this.fixSearch = true;
        }
    },
    mounted() {
        this.updateData();
        this.fetchPms();
        this.fetchPas();
        this.fetchProjectCatOptions();
        this.fetchVendors();
    },
    computed: {
        dateOfToday() {
            return moment().format('YYYY-MM-DD');
        },
        isAhooAgent() {
            return this.$store.getters['account/isAhooAgent'];
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
    },
    methods: {
        async updateData() {
            if (this.fixSearch) {
                const QUERY = JSON.stringify(this.queryParams);
                localStorage.setItem('project-list-query', QUERY);
            }

            try {
                this.isLoading = true;
                const resp = this.currentPage === 1 ? await this.getDetailList() : await this.getYearlyStatisticList();

                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
                this.progressOverview = resp.data.progressOverview;
                this.setSummaryData(resp);
                this.$nextTick(() => {
                    if (this.currentPage === 2) this.$refs.ProjectYearlyCompareTable.setChartData();
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onRefresh() {
            this.updateData();
        },
        setSummaryData(resp) {
            const summaryData = [];

            const TIME_RANGE_HEAD = Number(_.head(this.queryParams.pjStartDate));
            const TIME_RANGE_LAST = Number(_.last(this.queryParams.pjStartDate));
            const FIRST = moment(TIME_RANGE_HEAD).year();
            const END = moment(TIME_RANGE_LAST).year();

            for (let i = FIRST, j = 0; i <= END; i += 1, j += 1) {
                const OBJ = _.find(resp.data.statisticalList, ['startYear', i]);
                if (OBJ) summaryData.push(OBJ);
                else {
                    summaryData.push({
                        creditedAmountTwd: 0,
                        projectCount: 0,
                        startYear: i,
                        toBeCreditedAmountTwd: 0,
                        totalAmountTwd: 0,
                    });
                }
            }
            this.summaryData = summaryData;
        },
        setupTimeFormat() {
            const PJSDH = _.head(this.queryParams.pjStartDate);
            const PJSDL = _.last(this.queryParams.pjStartDate);
            const PJEDH = _.head(this.queryParams.pjEndDate);
            const PJEDL = _.last(this.queryParams.pjEndDate);

            const PJSDS = PJSDH ? moment(Number(PJSDH)).startOf('day').format('x') : undefined;
            const PJSDE = PJSDL ? moment(Number(PJSDL)).endOf('day').subtract(1, 'seconds').format('x') : undefined;
            const PJEDS = PJEDH ? moment(Number(PJEDH)).startOf('day').format('x') : undefined;
            const PJEDE = PJEDL ? moment(Number(PJEDL)).endOf('day').subtract(1, 'seconds').format('x') : undefined;

            return {
                StartDate: PJSDS,
                EndDate: PJSDE,
                ProjectEndDateStart: PJEDS,
                ProjectEndDateEnd: PJEDE,
            };
        },
        getDetailList() {
            // eslint-disable-next-line object-curly-newline
            const { StartDate, EndDate, ProjectEndDateStart, ProjectEndDateEnd } = this.setupTimeFormat();

            return this.$api({
                url: `ProjectManagementPage/GetProjectDetailList${this.getManualQuery(this.queryParams)}`,
                params: {
                    ...this.queryParams,
                    pjStartDate: undefined,
                    pjEndDate: undefined,
                    searchPMs: undefined,
                    searchPAs: undefined,
                    VDR_SNOs: undefined,
                    PJCAT_SNOs: undefined,
                    StartDate,
                    EndDate,
                    ProjectEndDateStart,
                    ProjectEndDateEnd,
                },

                method: 'GET',
            });
        },
        getYearlyStatisticList() {
            // eslint-disable-next-line object-curly-newline
            const { StartDate, EndDate, ProjectEndDateStart, ProjectEndDateEnd } = this.setupTimeFormat();

            return this.$api({
                url: `ProjectManagementPage/GetProjectYearlyStatisticalList${this.getManualQuery(this.queryParams)}`,
                params: {
                    ...this.queryParams,
                    pjStartDate: undefined,
                    pjEndDate: undefined,
                    searchPMs: undefined,
                    searchPAs: undefined,
                    VDR_SNOs: undefined,
                    PJCAT_SNOs: undefined,
                    StartDate,
                    EndDate,
                    ProjectEndDateStart,
                    ProjectEndDateEnd,
                },
                method: 'GET',
            });
        },

        async fetchProjectCatOptions() {
            const resp = await this.$api({
                url: 'ProjectManagementPage/GetProjectCategoryOptions',
                method: 'GET',
            });
            this.projectCatOptions = resp.data.options;
        },
        async fetchPms() {
            const USER_SNO = this.$store.getters['account/userSno'];
            const resp = await this.$api({
                url: 'ProjectManagementPage/GetPMList',
                method: 'GET',
            });

            if (this.isAuthOne(['C04', 'Q03'])) {
                this.pmOptions = _.chain(resp.data.items)
                    .filter((o) => (this.isAhooAgent ? true : o.nam !== 'Ahoo專員'))
                    .filter((o) => !!o.active || (!o.active && o.hasProject))
                    .filter(['pm', true])
                    .value();
            } else this.pmOptions = [_.find(resp.data.items, ['sno', USER_SNO])];
        },
        async fetchPas() {
            const resp = await this.$api({
                url: 'ProjectManagementPage/GetPAList',
                method: 'GET',
            });
            this.paOptions = _.chain(resp.data.items).value();
        },
        async fetchVendors(query) {
            const resp = await this.$api({
                url: 'ProjectManagementPage/GetVendorList',
                method: 'GET',
                params: { keyword: query },
            });

            this.vendorOptions = resp.data.options;
        },
        vendorRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchVendors(query);
        },
        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },
        getRowClass({ row }) {
            if (row.sno === this.projectDetailDialog.sno) {
                return 'curr-detail-dialog-target';
            }
            if (row.sno === this.projectDetailDialog.lastSno) {
                return 'last-detail-dialog-target';
            }
            return '';
        },
        onPaginationChange() {
            this.updateData();
        },
        onCurrentPageChange() {
            this.queryParams.PageNum = 1;

            if (this.currentPage === 2) {
                if (!this.queryParams.pjStartDate) this.queryParams.pjStartDate = [moment().format('x'), moment().format('x')];

                // 重置專案結束日期搜尋條件
                this.queryParams.pjEndDate = null;

                // 讓專案開始日期指定為整年區間
                const START_DATE = Number(_.head(this.queryParams.pjStartDate));
                const END_DATE = Number(_.last(this.queryParams.pjStartDate));

                this.queryParams.pjStartDate = [moment(START_DATE).startOf('year').format('x'), moment(END_DATE).endOf('year').subtract(1, 'seconds').format('x')];
            }

            this.updateData();
        },
        handleAddBtnClick() {
            this.$router.push({ name: 'project-add' });
        },
        handleDataRowClick(data) {
            this.projectDetailDialog.visible = true;
            this.projectDetailDialog.sno = data.sno;
            this.projectDetailDialog.lastSno = null;
        },
        handleDetailDialogClose() {
            this.projectDetailDialog.lastSno = this.projectDetailDialog.sno;
            this.projectDetailDialog.visible = false;
            this.projectDetailDialog.sno = null;
        },
        getManualQuery(query) {
            const returnValue = [
                ..._.map(query.searchPMs, (o) => `searchPMs=${o}`),
                ..._.map(query.searchPAs, (o) => `searchPAs=${o}`),
                ..._.map(query.VDR_SNOs, (o) => `VDR_SNOs=${o}`),
                ..._.map(query.PJCAT_SNOs, (o) => `PJCAT_SNOs=${o}`),
            ];
            return returnValue.length ? `?${returnValue.join('&')}` : '';
        },

        onPageClick(event) {
            if (event.target.classList.contains('ah-page') || event.target.classList.contains('ah-container')) {
                this.projectDetailDialog.lastSno = null;
            }
        },
        onFixSearchChange(val) {
            if (val) {
                const QUERY = JSON.stringify(this.queryParams);
                localStorage.setItem('project-list-query', QUERY);
            } else localStorage.removeItem('project-list-query');
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            // 或者檢查 e.isComposing (現代瀏覽器支援)
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.project-page {

    @media (max-width: 720px) {
        .page-header .title-row {
            display: flex;
            justify-content: space-between;
            align-items: end;
        }
    }

    .custom-actions {
        margin-right: 20px;
    }
    .query-input-row {
        display: flex;
        align-items: top;
        padding: 0px 20px 10px 0;
        gap: 0px;
        scrollbar-width: none;

        @media (max-width: 1070px) {
            min-width: 100%;
            overflow-x: auto;
        }

        > .item {
            margin-left: 12px;
            &:first-child {
                // margin-left: 0;
            }
        }

        .label {
            color: white;
            margin-bottom: 2px;
            font-size: 9pt;
            opacity: 0.85;
            white-space: nowrap;
        }
        .query-input {
            width: 100%;

            >* {
                width: 100%;
            }

            .el-date-editor {
                color: #fff;

                .el-range-separator {
                    color: #fff;
                }
            }

            .el-input__inner,
            .picker-inner {
                background-color: #322c7b;
                color: #fff;
                border: 0px solid rgba(0, 0, 0, 0.3);

                &:focus {
                    // border: 1px solid #fff;
                }

                // &:has(input:focus) {
                //     background-color: lightblue;
                //     border: 2px solid blue;
                // }
            }

            .el-select:has(input:focus) {
                // border: 1px solid red;
            }

            .el-tag {
                .el-select__tags-text {
                    color: #222;
                }
                .el-tag__close {
                    color: #fff;
                }
            }

            input.el-input {
                color: #fff;
            }

            input {
                background-color: transparent;
                color: #fff;

                &::placeholder {
                    color: rgba(255, 255, 255, 0.3);
                    font-size: 9pt;
                }

                &.el-input__inner {
                    color: #fff !important;
                }
            }
        }
    }

    .projects-statistic-table.el-table {
        th {
            font-weight: bold;
        }
        th.is-leaf,
        td {
            border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        }
        &::before,
        &.el-table--group::after,
        &.el-table--border::after {
            display: none;
        }
        .projects-statistic-table-label-block {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .square-block {
                width: 8px;
                height: 8px;
                margin-right: 5px;
                &.green {
                    background-color: #56c500;
                }
                &.yellow {
                    background-color: #fac300;
                }
            }
        }
    }

    .main-table {
        .table-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }
        .date-label {
            color: #aaa;
        }
    }
    .hint-label {
        text-align: right;
        margin-right: 20px;
        color: #aaa;
        font-size: 10pt;
    }
}
</style>

<style lang="scss">
.project-page {
    .projects-statistic-table {
        &.el-table,
        &.el-table__expanded-cell {
            background-color: transparent;
        }
        &.el-table th,
        &.el-table tr,
        &.el-table td {
            background-color: transparent;
        }
        &.el-table__row:hover,
        &.el-table--enable-row-hover .el-table__body tr:hover > td {
            background-color: transparent;
        }

        &.ah-el-data-table.el-table th,
        &.el-table .cell {
            color: white;
        }

        .cell {
            font-size: 12pt;
        }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #fff;
        color: #463cb2;
        border: 0;
        border-left: 0;
    }
    .table-option-block {
        margin-top: -5px;
        margin-left: 15px;
    }
    .table-option .el-radio-button__inner {
        // width: 100px;
        background-color: #8c84e0;
        color: white;
        border: 0;
        font-weight: bold;
        padding: 8px 13px;
        font-size: 9pt;
    }

    .el-range-separator {
        width: 20px;
    }
    .projects-statistic-table {
        .el-loading-mask {
            background-color: #463cb2cf;
        }
        .el-loading-spinner .path {
            stroke: #fff;
        }
    }
    .percentage {
        margin-top: -5px;
        font-size: 10pt;
        color: rgba(255, 255, 255, 0.5);
    }
    .el-table__footer-wrapper .cell {
        font-weight: bold;
    }

    .search-funcs {
        position: relative;
        top: -13px;
        display: flex;
        justify-content: end;
        color: #fff;
        padding: 0 20px;
        margin-bottom: -5px;
    }
}
</style>
